import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

const PLUS = '+'

type ProductVoucherReadonlyLabelProps = {
  id: string
}

export const ProductVoucherReadonlyLabel: FC<
  ProductVoucherReadonlyLabelProps
> = ({ id }) => {
  return (
    <span
      className="flex cursor-default items-center whitespace-nowrap rounded-full bg-light-tertiary px-3 py-1 text-xs"
      data-qa-id={`product-voucher-readonly-label-${id}`}
    >
      <span aria-hidden>{PLUS}</span>
      <FormattedMessage id="product.label.voucher" />
    </span>
  )
}
